@use 'sass:meta';
@use 'config';
@use '~@cewe-designsystem-stylecomponents/mixins/breakpoints';
@use '~@cewe-designsystem-stylecomponents/button';
@use '~@cewe-designsystem-stylecomponents/icon';

:host {
  display: block;
  position: relative;
  color: config.$partner-wizard-base-font-color;
  font-family: config.$partner-wizard-base-font-family;

  .root-buttons {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 1rem;
    max-width: 50rem;

    &.direction-row-reverse,
    &.direction-column-reverse {
      flex-direction: column-reverse;
    }

    @include breakpoints.breakpoint('sm', 'up') {
      flex-direction: row;

      &.direction-row-reverse {
        flex-direction: row-reverse;
      }

      &.direction-column {
        flex-direction: column;
        gap: 0;
      }

      &.direction-column-reverse {
        flex-direction: column-reverse;
        gap: 0;
      }
    }

    > * {
      display: flex;
      flex: 1 1;
      flex-direction: column;
    }

    .button-subline {
      margin: 0.4rem 0.2rem;
      font-size: 0.6875rem;

      /* stylelint-disable selector-max-compound-selectors */
      p {
        margin-top: 0;
        margin-bottom: 0.5rem;
      }
    }
  }

  csc-icon {
    @extend %csc-icon;
  }

  .hide-on-mobile {
    @include breakpoints.breakpoint('md', 'down') {
      display: none;
    }
  }

  .hide-on-desktop {
    @include breakpoints.breakpoint('md', 'up') {
      display: none;
    }
  }

  @include meta.load-css('buttons');
  @include meta.load-css('channels');
  @include meta.load-css('modal');
  @include meta.load-css('partners');
}
